import { __rest } from "tslib";
import React from 'react';
import { Copy, CopyCheck, CopyXmark } from '@gravity-ui/icons';
import { Icon } from '../Icon';
export function ClipboardIcon(_a) {
    var { status } = _a, rest = __rest(_a, ["status"]);
    if (status === 'error') {
        return React.createElement(Icon, Object.assign({ data: CopyXmark }, rest));
    }
    if (status === 'success') {
        return React.createElement(Icon, Object.assign({ data: CopyCheck }, rest));
    }
    return React.createElement(Icon, Object.assign({ data: Copy }, rest));
}
